import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var res;
export const updateDesignationTodo = createAsyncThunk('updateDesignation', async (data) => {
    try {
        const res = await axios({
            method: "put",
            url: process.env.REACT_APP_API_URL + `designation/${data?.id}`,
            data: {
                "name": data.designation,
                "status": data.status,
                // "modified_by": localStorage.getItem('userId')
            },
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + localStorage.getItem('token')
            }
        });

        // ✅ Return only serializable fields
        return res

    } catch (error) {
        return error?.response
    }
});
